// Verification.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import humanVerificationImage from '../assets/human-verification.png';
import WhatWeVerify from '../components/WhatWeVerify';

const Verification = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <motion.div 
              className="text-left"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <motion.h1 
                className="text-4xl md:text-5xl lg:text-5xl font-inter font-bold text-acBlack leading-tight"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.3 }}
              >
                Verification Services <br /><span className="text-2xl font-semibold"> Human-Verified, Evidence-Backed</span>
              </motion.h1>
              
              <motion.p 
                className="text-lg text-gray-600 mt-6 max-w-2xl"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.5 }}
              >
                Make decisions on facts, not guesses. Our trained case managers and field agents perform person-to-person verification across Nigeria, Kenya, Ghana, Zimbabwe, and South Africa. Every result ships with a signed, tamper-evident report and a clear outcome: Verified / Inconclusive / Discrepant.
              </motion.p>
              
              <motion.div 
                className="mt-8 flex flex-col sm:flex-row items-start gap-4"
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                transition={{ duration: 0.6, delay: 0.8 }}
              >
                <Link 
                  to="/contact" 
                  className="bg-acYellow hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
                >
                  Request a Verification
                </Link>
              </motion.div>
            </motion.div>

            {/* Right Image */}
            <motion.div 
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <img
                src={humanVerificationImage}
                alt="Verification Services"
                className="w-full h-auto"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* What We Verify Section */}
      <WhatWeVerify />

      {/* Additional sections can be added here */}
    </div>
  );
};

export default Verification;
